module.exports = __webpack_public_path__ + "static/image_insert_vend.b9feb6a0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/za/integrations/images/vend/image_insert_vend.jpg
// module id = 1603
// module chunks = 279379153958506